module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.2979/img/provider-ctas-blob-1x.png"